export const PLATFORM_WATERMARK_TEXT = "transcriptr.ai"

const BRAND_WATERMARK_GAP = 16
const PLATFORM_WATERMARK_DELAY_SECONDS = 5
const PLATFORM_WATERMARK_FADE_SECONDS = 0.5

export type BrandWatermarkPosition =
  | "top-left"
  | "top-right"
  | "bottom-left"
  | "bottom-right"
  | "custom"

/** Scale with the short edge so the wordmark stays readable across aspect ratios. */
export function platformWatermarkStyle(width: number, height: number) {
  const fontSize = Math.max(1, Math.round((Math.min(width, height) / 1080) * 48))
  const logoSize = Math.round(fontSize * 1.25)

  return {
    fontSize,
    logoSize,
    gap: Math.round(fontSize * 0.3),
    insetLeft: Math.round(width * 0.04),
    insetTop: Math.round(height * 0.028),
    blockHeight: logoSize,
  }
}

/** Fade after the opening hook; short clips must still have visible branding. */
export function platformWatermarkOpacity(frame: number, fps: number, durationInFrames: number): number {
  const lastFrame = durationInFrames - 1
  if (lastFrame <= 0) return 1

  const fadeFrames = Math.min(Math.max(1, Math.round(PLATFORM_WATERMARK_FADE_SECONDS * fps)), Math.ceil(lastFrame / 2))
  const startFrame = Math.min(Math.round(PLATFORM_WATERMARK_DELAY_SECONDS * fps), Math.max(0, lastFrame - 2 * fadeFrames))
  const progress = Math.max(0, Math.min(1, (frame - startFrame) / fadeFrames))
  return progress * progress * (3 - 2 * progress)
}

/** Reserve the top-left platform slot throughout the clip to avoid a brand jump. */
export function brandWatermarkTop(
  position: BrandWatermarkPosition,
  platformBlockHeight: number,
  platformInsetTop: number,
): number {
  if (position !== "top-left") return 0
  return platformInsetTop + platformBlockHeight + BRAND_WATERMARK_GAP
}
